import { call, put, takeLatest } from "redux-saga/effects";
import {
  updateHuseierneMembershipStatusError,
  updateHuseierneMembershipStatusStart,
  updateHuseierneMembershipStatusSucceded,
} from "./slice";

import { createRequest } from "Utils/requestUtils";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* updateHuseierneMembershipStatus({
  payload: { customerRef, huseierneMembershipStatus },
}: ReturnType<typeof updateHuseierneMembershipStatusStart>) {
  const url = `/open/insurance/carts/customers/${customerRef}`;
  try {
    yield call(createRequest, {
      method: "patch",
      requestBody: {
        partnerCustomerInfo: {
          huseierneMembershipStatus,
        },
      },
      url,
    });
    yield put(updateHuseierneMembershipStatusSucceded());
  } catch (e) {
    yield put(updateHuseierneMembershipStatusError());
  }
}

export function* updateHuseierneMembershipStatusSaga(): Generator {
  yield takeLatest(
    updateHuseierneMembershipStatusStart,
    updateHuseierneMembershipStatus,
  );
}
